<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'Provide file names' | messageTranslate }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body" [formArrayName]="FILENAMES_CONTROL_NAME">
    @for (control of fileNameFormArray.controls; track control; let i = $index) {
      <div class="row form-group">
        <label [for]="'filename' + i" class="col-auto col-form-label">{{ 'File name' | messageTranslate }}</label>
        <div class="col">
          <input [formControlName]="i" class="form-control" [id]="'filename' + i" [placeholder]="'File name' | messageTranslate">
          <app-errors [errors]="control.errors"/>
        </div>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" [disabled]="!form.valid">{{ 'OK' | messageTranslate }}</button>
    <button type="button" ngbAutofocus class="btn btn-secondary ms-2" (click)="onCancel()">{{ 'Cancel' | messageTranslate }}</button>
  </div>
</form>
